<script lang="js">
  /**
   * FAB Container.
   * - This is where the fab class and style is controlled.
   *
   * @param {String} id - The id of the fab.
   * @param {Object} fab - The fab object.
   * @param {Object} data - The data object.
   * @param {Object} animation - The animation object.
   * @param {String} shape - The shape of the fab.
   * @param {Boolean} display - Whether the fab is displayed.
   * @param {Boolean} rippleAnimation - Whether the ripple animation is displayed.
   * @param {Boolean} rotateAnimation - Whether the rotate animation is displayed.
   * @param {String} classNames - The class names of the fab.
   * @param {String} style - The style of the fab.
   */
  import FABContainer from "../helper/container";
  export let id = null;
  export let fab = {};
  export let data = {};
  export let animation = {};
  export let shape = "";
  export let display = true;
  export let rippleAnimation = false;
  export let rotateAnimation = false;
  export let classNames = "fab ";
  export let style = ``;

  // Variables.
  let { fab_design } = window.FAB_PLUGIN.options;
  let activeAnimation = "";
  let styleDisplay = "";
  let fullyLoaded = false;
  let backgroundColor = fab?.template?.color ?? fab_design.template.color;
  animation = FABContainer.get_container_animation(animation);
  classNames = FABContainer.get_container_class_name(classNames, shape);

  // Data Binding
  $: if (display) {
    activeAnimation = ` animate__${animation.in} `;
    styleDisplay = "display: flex;";
  } else {
    if (fullyLoaded && animation.out) {
      activeAnimation = ` animate__${animation.out} `;
    } else {
      styleDisplay = "display: none;";
      fullyLoaded = true;
    }
  }

  // Auto Trigger
  FABContainer.autotriggerType(fab);
</script>

<div
  {id}
  class="
        {classNames}
        {activeAnimation}
    "
  class:shadow-md={fab_design.template.name === "classic"}
  class:fab-rotate-animation={rotateAnimation}
  style="
        {fab_design.template.name !== 'shape' ? `background: ${backgroundColor};` : ''}
        {fab.tooltipDisplay ? `width:min-content;` : ''}
        {styleDisplay}
        font-size: {fab_design.font.size.value}{fab_design.font.size.unit};
        {fab_design.font.style === 'bold' ? `font-weight: bold;` : `font-style: ${fab_design.font.style};`}
        font-family: {fab_design.font.family};
        {style}
    "
  {...FABContainer.get_container_data(data)}
  on:click
>
  {@html FABContainer.ripple_dom_animation(animation, rippleAnimation, backgroundColor)}
  <slot></slot>
</div>
